import React from 'react';
import { message } from 'antd';

import PaginationBase from '../../../common/base/PaginationBase';

import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import dialog from '../../../common/utility/dialog';
import global from '../../../common/utility/global';
import estadoMock from '../../../common/mock/estadoMock';

import usuarioService from '../../../service/seguridad/usuarioService';
import rolService from '../../../service/seguridad/rolService';
import tipoDocumentoService from '../../../service/administracion/tipoDocumentoService';
import tipoComprobanteService from '../../../service/administracion/tipoComprobanteService';
import { OTROS, DNI, CARNET_EXTRANJERIA, PASAPORTE, RUC } from '../../../common/types/tipoDocumentoType';

import Header from '../../../components/Header';
import Filters from './Filters';
import ResultList from './ResultList';
import FormModal from './FormModal';
import ContraseniaModal from './ContraseniaModal';
import SeriesModal from './SeriesModal';
import ConfiguracionModal from './ConfiguracionModal';
import padronReducidoService from '../../../service/integracion/padronReducidoService';


import {
    BOLETA_DE_VENTA, FACTURA, NOTA_DE_CREDITO, NOTA_DE_DEBITO,
    GUIA_REMISION_REMITENTE, COTIZACION, NOTA_VENTA, PEDIDO, RETENCION,
    REQUERIMIENTO, ORDEN_COMPRA, ORDEN_SERVICIO, GUIA_TRANSPORTISTA, CONTROL_CREDITO,
    TRANSFERENCIA
} from '../../../common/types/tipoComprobanteType';

export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();
        this.state = {
            loadingExcel: false,
            loadingPdf: false,
            loadingPrint: false,
            loadingConfiguracion: false,
            estados: estadoMock.values,
            tiposDocumento: [],
            tiposComprobante: [],
            detalles_cobranza: [],
            detalles_ventas: [],
            roles: [],
            filter: {
                usuario: '',
                estado: '',
                ...FILTER
            },
            pagination: PAGINATION,
            visible: false,
            visibleContrasenia: false,
            visibleSeries: false,
            visibleConfiguracion: false,
            formValues: this.fetchEmptyFormValues(),
            formValuesContrasenia: { id: 0, password: '' },
            formValuesSeries: { idUsuario: 0, listaSerieUsuario: [] },
            //registro de permisos avanzados

            searchPermisoFormValues: {
                nombre: "",
                dataSource: [],
                selectedRowKeys: [],
                selectedColumnKeys: [],

            },
            idRol: undefined,
            idUsuario: undefined,
            detalleCobranza: [],
            detalleVenta: [],

        }
    }

    /********* PAGINATION ********/

    fetchEmptyFormValues = () => {
        return {
            id: 0,
            usuario: '',
            password: '',
            idTipoDocumento: DNI.ID,
            idRol: 0,
            numeroDocumento: '',
            nombre: '',
            apellidoPaterno: '',
            apellidoMaterno: '',
            correo: '',
            tiposDocumento: [],
            flagPermisoComprobanteContingencia: false,
            flagPermisoCaja: false,
            roles: [],
            flagPermisoMV: false,
            flagPermisoMC: false,
            flagPermisoML: false,
            flagPermisoOC: false,
            flagPermisoOS: false,
            flagPermisoOP: false,
            flagPermisoCC: false,
            flagPermisoTS: false,
            flagPermisoFC: false,
            flagPermisoGCG: false,
            flagPermisoUTC: false,
            //---------------------------------

            searchLoading: false,

        };
    };

    handleClearFilters = () => {
        var filter = {
            usuario: '',
            estado: '',
            ...FILTER
        };
        this.setState({ filter });
        this._handlePagination(filter);
    };

    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this._handlePagination(filter);
        }
    };

    handleChange = (property, value) => {
        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });
    };


    handleChangeConfiguration = (property, value) => {
        debugger
        var value = (value == 1 ? true : false);
        const formValues = { ...this.state.formValues, [property]: value };
        this.setState({ formValues });
    };

    handleDeleteActive = (values) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;
            if (values.flag)
                response = await usuarioService.eliminar(values);
            else
                response = await usuarioService.activar(values);

            if (response.status === 200) {
                message.success('Proceso realizado correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    handleExportExcel = async () => {
        this.setState({ loadingExcel: true });
        var response = await usuarioService.excel(this.state.filter);
        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Usuarios.xlsx");
    }

    handleExportPdf = async () => {
        this.setState({ loadingPdf: true });
        var response = await usuarioService.pdf(this.state.filter);
        this.setState({ loadingPdf: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Usuarios.pdf");
    }

    handlePrint = async () => {
        this.setState({ loadingPrint: true });
        var response = await usuarioService.pdf(this.state.filter);
        this.setState({ loadingPrint: false });
        if (response !== undefined) {
            var file = window.URL.createObjectURL(response.data);
            var win = window.open(file, '_blank');
            win.focus();
        }
    }

    /******************** FORM MODAL *****************/

    handleNew = () => {
        var formValues = this.fetchEmptyFormValues();
        formValues.tiposDocumento = this.state.tiposDocumento;
        formValues.roles = this.state.roles;
        this.setState({ visible: true, formValues });
    };

    handleEdit = async (values) => {

        const response = await usuarioService.obtenerPorId(values.id);
        if (response !== undefined) {
            response.roles = this.state.roles;
            response.tiposDocumento = this.state.tiposDocumento;
            this.setState({ visible: true, formValues: response });
        }
    };

    handleEditContrasenia = async (values) => {

        const response = await usuarioService.obtenerPorId(values.id);
        if (response !== undefined) {
            this.setState({ visibleContrasenia: true, formValuesContrasenia: response });
        }
    };


    handleAsignarSeries = async (values) => {

        var formValuesSeries = { idUsuario: values.id, listaSerieUsuario: [] };

        const response = await usuarioService.listarSeriesPorIdUsuario(values.id);
        if (response !== undefined) {

            response.forEach(element => {
                formValuesSeries.listaSerieUsuario.push({
                    identifier: global.fetchUniqueCode(),
                    idTipoComprobante: element.idTipoComprobante,
                    serie: element.serie,
                    documento: element.documento
                });
            });
            this.setState({ visibleSeries: true, formValuesSeries });
        }
    };

    handleSave = (values, form) => {

        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;
            if (values.id === 0)
                response = await usuarioService.registrar(values);
            else
                response = await usuarioService.modificar(values);

            if (response.status === 200) {
                form.resetFields();
                this.setState({ visible: false });
                message.success((values.id === 0 ? 'Registrado' : 'Modificado') + ' correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    handleSaveContrasenia = (values, form) => {

        dialog.confirm("¿Esta seguro de modificar la contraseña?", async () => {
            var response = await usuarioService.modificarContraseniaAdmin(values);

            if (response.status === 200) {
                form.resetFields();
                this.setState({ visibleContrasenia: false });
                message.success('Modificado correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    handleSaveSerie = async (item, form) => {

        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response = await usuarioService.modificarSerie(item);

            if (response.status === 200) {
                form.resetFields();
                this.setState({ visibleSeries: false });
                message.success((item.id === 0 ? 'Registrado' : 'Modificado') + ' correctamente.');
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });

    };

    handleAddSerie = () => {

        var listaSerieUsuario = this.state.formValuesSeries.listaSerieUsuario ? this.state.formValuesSeries.listaSerieUsuario : [];

        listaSerieUsuario.push({
            identifier: global.fetchUniqueCode(),
            idUsuario: this.state.formValuesSeries.idUsuario,
            idTipoComprobante: 0,
            serie: ""
        });

        this.setState({
            formValuesSeries: {
                ...this.state.formValuesSeries,
                listaSerieUsuario: listaSerieUsuario
            }
        });
    };

    handleRemoverSerie = (item) => {
        var listaSerieUsuario = this.state.formValuesSeries.listaSerieUsuario.filter(m => m.identifier !== item.identifier);
        this.setState({
            formValuesSeries: {
                ...this.state.formValuesSeries,
                listaSerieUsuario: listaSerieUsuario
            }
        });
    };

    handleEditConfiguracion = async (values) => {

        this.setState({ loadingConfiguracion: true });

        const response = await usuarioService.obtenerPorId(values.id);
        if (response !== undefined) {
            response.roles = this.state.roles;
            response.tiposDocumento = this.state.tiposDocumento;
            response.id = values.id
        }

        const permisos = await usuarioService.usarioCobranza(values.id, 0);
        var selected = this.handleChildren(permisos, values.id);
        var selectedColumn = this.handleChildrenEstablecimiento(permisos, values.id);

        this.setState({
            searchPermisoFormValues: {
                ...this.state.searchPermisoFormValues,
                dataSource: permisos,
                selectedRowKeys: selected,
                selectedColumnKeys: selectedColumn
            },
            idUsuario: values.id,
            visibleConfiguracion: true,
            formValues: response,
            loadingConfiguracion: false,
        });

    };

    handleSaveConfiguracion = (values, form) => {

        const formValues = { ...this.state.formValues };
        formValues.id = values.id;
        formValues.detalleCobranza = formValues.flagPermisoCaja ? (this.state.detalleCobranza.length == 0 ? null : JSON.stringify(this.state.detalleCobranza)) : null
        formValues.detalleVenta = this.state.detalleVenta.length > 0 ? JSON.stringify(this.state.detalleVenta) : null

        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {

            var response = await usuarioService.modificarConfiguracion(formValues);

            if (response.status === 200) {
                form.resetFields();
                this.setState({ visibleConfiguracion: false });
                message.success((values.id === 0 ? 'Registrado' : 'Modificado') + ' correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    handleBuscarPadronReducido = async (idTipoDocumento, numeroDocumento, form) => {

        this.setState({ formValues: { ...this.state.formValues, searchLoading: true } });
        const response = await padronReducidoService.entidad({ idTipoDocumento, numeroDocumento });

        if (response.status === 200) {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    searchLoading: false
                }
            }, () => {
                form.setFieldsValue({
                    razonSocial: response.data.razonSocial,
                    direccion: response.data.direccion,
                    nombre: response.data.nombre,
                    apellidoMaterno: response.data.apellidoMaterno,
                    apellidoPaterno: response.data.apellidoPaterno
                });
            });
        }
        if (response.status === 400) {
            dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
            return;
        }
        else {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    searchLoading: false
                }
            });
        }

    };

    //#region  "Configuracion avanzada"

    handleSelectColumn = (selected, rows) => {
        debugger
        var detalle = this.state.detalles_ventas;
        rows = new Array();
        selected.forEach(element => {
            detalle.forEach(item => {
                if (item.rowIndex == element) {
                    var obj = {
                        idAlmacen: item.idAlmacen,
                        idEstablecimiento: item.idEstablecimiento,
                        idUsuario: this.state.idUsuario,
                        rowIndex: item.rowIndex
                    }
                    rows.push(obj);
                }
            });

        });

        this.setState({
            detalleVenta: rows,
            searchPermisoFormValues: {
                ...this.state.searchPermisoFormValues,
                selectedColumnKeys: selected
            }
        });




    };

    handleSelect = (selected, rows) => {
        debugger
        var detalle = this.state.detalles_cobranza;
        rows = new Array();
        selected.forEach(element => {
            detalle.forEach(item => {
                if (item.rowIndex == element) {
                    var obj = {
                        idEstablecimiento: item.idEstablecimiento,
                        idUsuario: this.state.idUsuario,
                        rowIndex: item.rowIndex,
                        serie: item.serie,
                    }
                    rows.push(obj);
                }
            });

        });

        this.setState({
            detalleCobranza: rows,
            searchPermisoFormValues: {
                ...this.state.searchPermisoFormValues,
                selectedRowKeys: selected
            }
        });


    };

    handleChildren = (array, idUsuario) => {
        var row = new Array();
        var detalleCobranza = new Array();
        var detalles_cobranza = new Array();
        var selected = array == undefined ? [] : array[0].valor;
        if (array == undefined) {
            return false;
        }

        array.forEach(element => {
            element.lstSerie.forEach(item => {
                item.idEstablecimiento = element.idEstablecimiento;
                detalles_cobranza.push(item);
            });

        });




        if (selected.length == 0) {

            detalles_cobranza.forEach(fill => {
                if (fill.idUsuario == idUsuario) {
                    row.push(fill.rowIndex);
                    var obj = {
                        idEstablecimiento: fill.idEstablecimiento,
                        idUsuario: idUsuario,
                        rowIndex: fill.rowIndex,
                        serie: fill.serie,
                    }
                    detalleCobranza.push(obj);
                }
            });

        } else {
            selected.forEach(item2 => {
                var fill = detalles_cobranza.filter(e => e.serie == item2.serie);
                if (fill.length > 0) {
                    row.push(fill[0].rowIndex);
                    var obj = {
                        idEstablecimiento: fill[0].idEstablecimiento,
                        idUsuario: idUsuario,
                        rowIndex: fill[0].rowIndex,
                        serie: fill[0].serie,
                    }
                    detalleCobranza.push(obj);
                }
            });
        }


        this.setState({
            detalleCobranza: detalleCobranza,
            detalles_cobranza

        });
        return row;
    }

    handleChildrenEstablecimiento = (array, idUsuario) => {
        debugger
        var row = new Array();
        var detalleVenta = new Array();
        var selected = array == undefined ? [] : array[0].valorAlmacen;
        var detalles_ventas = new Array();
        if (array == undefined) {
            return false;
        }
        array.forEach(element => {

            element.lstAlmacen.forEach(item => {
                item.idUsuario = element.idUsuario;
                item.idEstablecimiento = element.idEstablecimiento;
                detalles_ventas.push(item);
            });
        });

        if (selected.length == 0) {

            detalles_ventas.forEach(item => {
                if (item.idUsuario == idUsuario) {

                    row.push(item.rowIndex);
                    item.idEstablecimiento = item.idEstablecimiento;
                    item.idUsuario = idUsuario;
                    detalleVenta.push(item);
                }

            });

        } else {

            selected.forEach(item2 => {
                var fill = detalles_ventas.filter(e => e.idAlmacen == item2.idAlmacen);
                if (fill.length > 0) {
                    row.push(fill[0].rowIndex);
                    var obj = {
                        idEstablecimiento: fill[0].idEstablecimiento,
                        idUsuario: idUsuario,
                        rowIndex: fill[0].rowIndex,
                        idAlmacen: fill[0].idAlmacen,

                    }
                    detalleVenta.push(obj);
                }
            });

        }


        this.setState({
            detalleVenta: detalleVenta,
            detalles_ventas

        });
        return row;
    }







    //#endregion
    async componentDidMount() {

        this._initPagination(this.state.filter, usuarioService.paginacion);
        const tiposDocumento = await tipoDocumentoService.listarExcluirPlaca();
        const tiposComprobante = await tipoComprobanteService.listar();
        const roles = await rolService.listar();
        var tiposComprobanteFilter = tiposComprobante.filter(m => m.id === FACTURA.ID || m.id === BOLETA_DE_VENTA.ID || m.id === NOTA_DE_CREDITO.ID || m.id === NOTA_DE_DEBITO.ID || m.id === GUIA_REMISION_REMITENTE.ID || m.id == COTIZACION.ID || m.id == NOTA_VENTA.ID || m.id == PEDIDO.ID ||
            m.id == RETENCION.ID || m.id == REQUERIMIENTO.ID || m.id == ORDEN_COMPRA.ID || m.id == ORDEN_SERVICIO.ID || m.id == GUIA_TRANSPORTISTA.ID || m.id === CONTROL_CREDITO.ID
            ||  m.id === TRANSFERENCIA.ID);
        this.setState({
            loadingSource: false,
            tiposComprobante: tiposComprobanteFilter ? tiposComprobanteFilter : [],
            tiposDocumento: tiposDocumento ? tiposDocumento : [],
            roles: roles ? roles : []

        });
    }

    render() {
        // const { getFieldDecorator } = this.props.form;
        return (
            <div>
                <Header
                    title="Usuario"
                    onNew={this.handleNew}
                    onSearch={() => this._handlePagination({ ...this.state.filter, ...FILTER })}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    estados={this.state.estados}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                />
                <ResultList
                    pagination={this.state.pagination}
                    loadingExcel={this.state.loadingExcel}
                    loadingPdf={this.state.loadingPdf}
                    loadingConfiguracion={this.state.loadingConfiguracion}

                    loadingPrint={this.state.loadingPrint}
                    onExportExcel={this.handleExportExcel}
                    onExportPdf={this.handleExportPdf}
                    onPrint={this.handlePrint}
                    onEdit={this.handleEdit}
                    onEditContrasenia={this.handleEditContrasenia}
                    onAsignarSeries={this.handleAsignarSeries}
                    onDeleteActive={this.handleDeleteActive}
                    onChange={this._handleChangePagination}
                    onAsignarPermisos={this.handleEditConfiguracion}

                />
                <FormModal
                    visible={this.state.visible}
                    formValues={this.state.formValues}
                    onClose={() => this.setState({ visible: false })}
                    onSave={this.handleSave}
                    onBuscarPadronReducido={this.handleBuscarPadronReducido}

                />
                <ContraseniaModal
                    visibleContrasenia={this.state.visibleContrasenia}
                    formValues={this.state.formValuesContrasenia}
                    onClose={() => this.setState({ visibleContrasenia: false })}
                    onSaveContrasenia={this.handleSaveContrasenia}
                />
                <SeriesModal
                    tiposComprobante={this.state.tiposComprobante}
                    visibleSeries={this.state.visibleSeries}
                    formValues={this.state.formValuesSeries}
                    onClose={() => this.setState({ visibleSeries: false })}
                    onAgregarSerie={this.handleAddSerie}
                    onRemoverSerie={this.handleRemoverSerie}
                    onSaveSeries={this.handleSaveSerie}
                />

                <ConfiguracionModal
                    visibleConfiguracion={this.state.visibleConfiguracion}
                    formValues={this.state.formValues}
                    onChangeRow={this.handleSelect}
                    searchPermiso={this.state.searchPermisoFormValues}
                    onChangeColumn={this.handleSelectColumn}

                    onClose={() => this.setState({ visibleConfiguracion: false })}
                    onSave={this.handleSaveConfiguracion}
                    onChange={this.handleChangeConfiguration}
                />
            </div>
        );
    };
}